var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},_vm._l((_vm.total),function(n){return _c('span',{key:n,on:{"click":function($event){return _vm.changePageFn(n)}}},[_vm._v(" "+_vm._s(n)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }